export enum FocusShapeType {
  Circle = 'circle',
  Square = 'square',
  Triangle = 'triangle',
  Star = 'star',
  Heart = 'heart',
  Diamond = 'diamond',
  CrossPlus = 'crossPlus',
  Hexagon = 'hexagon',
  Teardrop = 'teardrop',
  Lightning = 'lightning',
}

export const SHAPES_BY_LEVEL: FocusShapeType[][] = [
  [], // Level 0 (unused)
  [FocusShapeType.Circle], // Level 1
  [FocusShapeType.Circle, FocusShapeType.Square], // Level 2
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle], // Level 3
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star], // Level 4
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star, FocusShapeType.Heart], // Level 5
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star, FocusShapeType.Heart, FocusShapeType.Diamond], // Level 6
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star, FocusShapeType.Heart, FocusShapeType.Diamond, FocusShapeType.CrossPlus], // Level 7
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star, FocusShapeType.Heart, FocusShapeType.Diamond, FocusShapeType.CrossPlus, FocusShapeType.Hexagon], // Level 8
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star, FocusShapeType.Heart, FocusShapeType.Diamond, FocusShapeType.CrossPlus, FocusShapeType.Hexagon, FocusShapeType.Teardrop], // Level 9
  [FocusShapeType.Circle, FocusShapeType.Square, FocusShapeType.Triangle, FocusShapeType.Star, FocusShapeType.Heart, FocusShapeType.Diamond, FocusShapeType.CrossPlus, FocusShapeType.Hexagon, FocusShapeType.Teardrop, FocusShapeType.Lightning], // Level 10
];
